import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  IconButton,
  Divider,
} from "@mui/material";

import { Delete, Close, Warning } from "@mui/icons-material";

const DeleteNotes = ({ open, onClose, handleDelete }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 24px 0 24px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Warning size={20} color="#dc2626" />
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1f2937",
              padding: 0,
            }}
          >
            Confirmar eliminación
          </DialogTitle>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            color: "#6b7280",
            padding: "4px",
            "&:hover": {
              backgroundColor: "#f3f4f6",
              color: "#374151",
            },
          }}
        >
          <Close size={18} />
        </IconButton>
      </Box>

      <Divider sx={{ margin: "16px 0", borderColor: "#e5e7eb" }} />

      <DialogContent sx={{ padding: "0 24px" }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            fontSize: "14px",
            color: "#4b5563",
            lineHeight: "1.6",
            margin: 0,
          }}
        >
          Esta acción eliminará permanentemente el elemento seleccionado. Esta
          operación no se puede deshacer.
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "20px 24px 24px 24px",
          gap: "8px",
          justifyContent: "flex-end",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: "6px",
            textTransform: "none",
            fontSize: "14px",
            padding: "8px 16px",
            color: "#6b7280",
            borderColor: "#d1d5db",
            backgroundColor: "#ffffff",
            minWidth: "80px",
            "&:hover": {
              borderColor: "#9ca3af",
              backgroundColor: "#f9fafb",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          sx={{
            borderRadius: "6px",
            textTransform: "none",
            fontSize: "14px",
            padding: "8px 16px",
            minWidth: "80px",
            backgroundColor: "#dc2626",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#b91c1c",
            },
            "&:focus": {
              boxShadow: "0 0 0 3px rgba(220, 38, 38, 0.2)",
            },
          }}
          autoFocus
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNotes;
